import { Skeleton } from "~/components/ui/skeleton";

export function VideoCardSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="aspect-[9/16] w-full rounded-lg" />
      <Skeleton className="h-3.5 w-full" />
      <Skeleton className="h-3 w-2/3" />
    </div>
  );
}
